import { SchoolStatusEnum } from "../../shared/ModelEnums";

import SchoolAddressModel from "./SchoolAddressModel";
import SchoolOfficerViewModel from "./SchoolOfficerModel";

export default class SchoolDetailsModel {
  // fundingArea: FundingAreaViewModel;
  schoolStatusCd: SchoolStatusEnum;
  statusChangeReason: string = "";
  reference: string;
  name: string;
  acaraId?: number;
  approxStudentsNum: number;
  phoneNumber: string;
  bankAccountBSB: string = "";
  bankAccountNumber: string = "";
  bankAccountName: string = "";
  concurrencyRV: string = "";
  schoolAddresses: SchoolAddressModel[] = [];
  postalAddress?: SchoolAddressModel;
  // recordStatus: string = "";
  schoolOfficers: SchoolOfficerViewModel[] = [];
  registrationRefusalReason: string = "";
  emailAddress: string = "";

  hasBankDetailsInd: boolean = false;

  accountBalance: number = 0;

  constructor() {
    // this.fundingArea = new FundingAreaViewModel();
    // this.fundingArea.reference = "N01";
    this.schoolStatusCd = SchoolStatusEnum.SS_PP;
    this.reference = "";
    this.name = "";
    this.approxStudentsNum = 0;
    this.phoneNumber = "";
    this.schoolAddresses.push(new SchoolAddressModel());
  }
}
